import { defineComponent as _defineComponent } from 'vue'
import useRoomMoreControl from './useRoomMoreHooks';
import SvgIcon from '../common/base/SvgIcon.vue';
import CopyIcon from '../common/icons/CopyIcon.vue';
import EmailIcon from '../common/icons/EmailIcon.vue';
import TuiButton from '../common/base/Button.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'indexPC',
  setup(__props) {

const { t, onCopy, handleClick, email, isZH } = useRoomMoreControl();

return { __sfc: true,t, onCopy, handleClick, email, isZH, SvgIcon, CopyIcon, EmailIcon, TuiButton }
}

})